import type { APIClient } from '@src/corelib/api';
import type { ResourceUser, ResourceUserDto } from '@src/types';
import prefetchQuery from '../prefetchQuery';
import useQuery from '../useQuery';
import { workingTimeFromDto } from '../worktime';

const absToolResourcesUrl = 'users/abs_tool_resources/';

export function prefetchResourceUsers(client: APIClient) {
  prefetchQuery(absToolResourcesUrl, client, {});
}

export function useResourceUsers() {
  const query = useQuery<ResourceUserDto[], ResourceUser[]>(
    absToolResourcesUrl,
    {
      select: (data: Array<ResourceUserDto>) => data.map(resourceUserFromDto),
      initialData: [],
    },
  );

  const { data: users = [], ...restQuery } = query;
  return {
    users,
    ...restQuery,
  };
}

function resourceUserFromDto(user: ResourceUserDto): ResourceUser {
  return {
    id: user.id,
    email: user.email,
    name: user.name,
    firstName: user.user_first_name,
    familyName: user.user_family_name,
    language: user.user_language,
    managerId: user.user_manager,
    worktime: user.worktime.map((w) => workingTimeFromDto(w)),
  };
}
